// extracted by mini-css-extract-plugin
export default {"person-name-container":"CollaboratorTableRow_person-name-container__w6qnx"};